import { render, staticRenderFns } from "./CountryEdit.vue?vue&type=template&id=2d2ba3de&scoped=true&"
import script from "./CountryEdit.vue?vue&type=script&lang=js&"
export * from "./CountryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ba3de",
  null
  
)

export default component.exports